import { render } from "./SidebarMenu3.vue?vue&type=template&id=5a2647b0&scoped=true"
import script from "./SidebarMenu3.vue?vue&type=script&lang=js"
export * from "./SidebarMenu3.vue?vue&type=script&lang=js"

import "./SidebarMenu3.vue?vue&type=style&index=0&id=5a2647b0&lang=scss&scoped=true"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2647b0"]])

export default __exports__